const wallConstructionData = [
  { material: `AAC Blocks`, thermal_resistance: 1.63 },
  { material: ` Solid burnt clay brick`, thermal_resistance: 0.235 },
  { material: `Internal plaster 25mm`, thermal_resistance: 0.035 },
  { material: `Concrete Block 25/50`, thermal_resistance: 0.165 },
  { material: `Concrete Block 30/60`, thermal_resistance: 0.163 },
  { material: `Foam Cement Block`, thermal_resistance: 1.448 },
  { material: `Gypsm Plaster 10mm`, thermal_resistance: 0.01953125 },
  { material: `Internal paint-Acrylic Emulsion`, thermal_resistance: 0.001587302 },
  { material: `Exterior grade paint- Acrylic`, thermal_resistance: 0.001587302 },
  { material: `Gypsm Putty 10mm `, thermal_resistance: 0.02 },

  { material: `Cement stabilized soil block (CSEB)ECBC R`, thermal_resistance: 0.22417154 },
  { material: `Resource efficient (hollow) brickECBC R`, thermal_resistance: 0.364500792 },
  { material: `Flyash Brick 150mm`, thermal_resistance: 0.175233645 },
  { material: `Hollow Concrete Block 200mm`, thermal_resistance: 1.013 },
  { material: `150 mm Reinforced Cement Concrete (RCC) Wall`, thermal_resistance: 0.3 },
  { material: `200 mm Solid Concrete Block (SCB) Wall with Cement Plaster`, thermal_resistance: 0.35 },
  { material: `230 mm Brick Wall with Cement Plaster`, thermal_resistance: 0.51 },
  { material: `200 mm Autoclaved Aerated Concrete (AAC) Block Wall with Cement Plaster`, thermal_resistance: 1.44 },
  { material: `300 mm AAC Block Wall with Cement Plaster`, thermal_resistance: 2.08 },
  { material: `15mm Plaster (External); 170mm Monolithic concrete wall, 10mm Plaster (Internal)`, thermal_resistance: 0.31 },
  { material: `20mm Plaster (external); 200mm Monolithic concrete wall; 15mm Plaster (Internal)`, thermal_resistance: 0.33 },
  { material: `15 mm Exterior plaster; 230mm Industrial Slag Brick; 10mm Interior plaster`, thermal_resistance: 10.7 },
  { material: `20mm Plaster (external); 150mm Fly Ash brick; 15mm Plaster (Internal)`, thermal_resistance: 0.38 },
  { material: `20mm Plaster (external); 200mm AAC blocks; 10mm Plaster (Internal)`, thermal_resistance: 1.23 },
  { material: `20mm Plaster (external) 230 mm Brick wall; 40 mm air cavity; 115 mm brick wall`, thermal_resistance: 0.83 },
  { material: `20mm Plaster (external); 200mm Monolithic concrete; 15mm Plaster (Internal)`, thermal_resistance: 0.33 },

  { material: `Concrete M-15, A-40, 7 Days 150mm`, thermal_resistance: 0.101 },
  { material: `Concrete M-25, A-40, 7 Days 150mm`, thermal_resistance: 0.119 },
  { material: `Concrete M-20, A-40, 7 Days 150mm`, thermal_resistance: 0.09 },
  { material: `Concrete M-15, A-40, 28 Days 150mm`, thermal_resistance: 0.098 },
  { material: `Concrete M-15, A-20, 7 Days 150mm`, thermal_resistance: 0.122 },
  { material: `Concrete M-25, A-40, 28 Days x150mm`, thermal_resistance: 0.114 },
  { material: `Concrete M-20, A-40, 28 Days 150mm`, thermal_resistance: 0.101 },
  { material: `Low Carbon Plaster 67mm`, thermal_resistance: 0.058 },
  { material: `Nushar Poly Insu Mortar 20mm`, thermal_resistance: 0.027 },
  { material: `Hollow Concrete Block 200mm`, thermal_resistance: 0.197 },
  { material: `Concrete M-15,A75 7 Days 220mm`, thermal_resistance: 0.189 },
  { material: `Lime concrete-10mm`, thermal_resistance: 0.014 },
  { material: `Mud Phuska-100mm`, thermal_resistance: 0.193 },
  { material: `Cement mortar-10mm`, thermal_resistance: 0.014 },
  { material: `Cement plaster-10mm`, thermal_resistance: 0.014 },
  { material: `Gypsum plaster-10mm`, thermal_resistance: 0.02 },
  { material: `1.25 cm cement plaster + 20.00 cm brick + 1.25 cm cement plaster`, thermal_resistance: 0.438596491 },
  { material: `1.25 cm cement plaster + 22.5 cm brick + 1.25 cm cement plaster`, thermal_resistance: 0.469483568 },
  { material: `1.25 cm cement plaster + 7.5 cm brick + 5.0 cm air gap + 7.5 cm brick + 1.25 cm cement plaster`, thermal_resistance: 0.555555556 },
  { material: `1.25 cm cement plaster + 11.25 cm brick + 5.0 cm air gap + 11.25 cm brick + 1.25 cm cement plaster`, thermal_resistance: 0.64516129 },

  { material: `1.25 cm cement plaster + 2.5 cm expanded polystyrene + 22.5 cm brick + 1.25 cm cement plaster`, thermal_resistance: 1.176470588 },

  { material: `1.25 cm cement plaster + 22.5 cm brick + 2.5 cm expanded polystyrene + 1.25 cm cement plaster`, thermal_resistance: 1.176470588 },

  { material: `20 cm dense concrete-hollow block (2 holes)`, thermal_resistance: 0.332225914 },

  { material: `20 cm dense concrete-hollow block (3 holes)`, thermal_resistance: 0.358422939 },

  { material: `1.25 cm cement plaster + 5 cm foam concrete + 11.25 cm concrete+ 1.25 cm cement plaster`, thermal_resistance: 1.01010101 },

  { material: `1.25 cm cement plaster + 20 cm AAC Block + 1.25 cm cement plaster`, thermal_resistance: 1.282051282 },

  { material: `1.25 cm cement plaster + 30 cm AAC Block + 1.25 cm cement plaster`, thermal_resistance: 1.818181818 },

  { material: `15 cm monolithic concrete`, thermal_resistance: 0.285714286 },

  { material: `20 cm Hollow burnt clay block – 750-850 kg/m3`, thermal_resistance: 0.769230769 },

  { material: `20 cm Hollow burnt clay block – 694 kg/m3`, thermal_resistance: 1 },

  // Add any data above this commment
  // Any data added should follow the same syntax
];

export { wallConstructionData };
